import React from 'react';
import { motion } from 'framer-motion';
import '../styles/main.css';
import heroVideo from '../assets/hero.mp4';
import chicken from '../assets/chicken.jpg';
import mutton from '../assets/mutton.jpg';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const Home = () => {
  return (
    <div className="royal-background">

      {/* Hero Section */}
      <section className="hero-container">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div className="hero-content">
          <h1>Welcome Hungry King</h1>
          <p>Royal Biryani Crafted for Kings</p>
          <a href="/menu"><button className="primary-btn">Explore Menu</button></a>
        </div>
      </section>

      {/* Signature Dishes */}
      <motion.section
        className="featured-section section-wrapper"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2 className="section-title">Our Signature Dishes</h2>
        <div className="featured-items">
          <div className="dish-card">
            <img src={chicken} alt="Chicken Dum Biryani" />
            <h3>Chicken Dum Biryani</h3>
            <p>Slow-cooked with authentic spices.</p>
          </div>
          <div className="dish-card">
            <img src={mutton} alt="Mutton Dum Biryani" />
            <h3>Mutton Dum Biryani</h3>
            <p>Tender, juicy and full of flavor.</p>
          </div>
        </div>
      </motion.section>

      {/* Why Choose Us */}
      <motion.section
        className="trust-section section-wrapper"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2 className="section-title">Why Choose my Hungry King?</h2>
        <ul className="trust-list">
          <li>🍛 Authentic Dum Biryani Recipes</li>
          <li>🧼 Hygienically Cooked and Packed</li>
          <li>⚡ Superfast Royal Delivery</li>
          <li>👑 Royal Flavors for Every Bite</li>
        </ul>
      </motion.section>

      {/* Testimonials */}
      <motion.section
        className="testimonials section-wrapper"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2 className="section-title">What Our Customers Say</h2>
        <div className="testimonial-slider">
          <blockquote>
            “Hands down the best biryani I’ve ever had. 5 stars!” — <strong>Raj K.</strong>
          </blockquote>
          <blockquote>
            “Truly a royal experience from the first bite to the last.” — <strong>Anita M.</strong>
          </blockquote>
        </div>
      </motion.section>

      {/* Call To Action */}
      <motion.section
        className="cta-banner section-wrapper"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Ready to Taste Royalty?</h2>
        <a href="/menu"><button className="primary-btn large">Order Now</button></a>
      </motion.section>
    </div>
  );
};

export default Home;